import type { RouteObject } from "react-router";
import type { AppModule } from "../types";
import { s } from "./strings";

const shellRoutes: RouteObject[] = [
  {
    path: "/manage-api-keys",
    handle: { title: s.userTitle },
    lazy: () => import("./pages/ManageApiKeysPage").then((m) => ({ Component: m.ManageApiKeysPage })),
  },
  {
    path: "/webhooks",
    handle: { title: s.webhooksTitle },
    lazy: () => import("./pages/WebhooksPage").then((m) => ({ Component: m.WebhooksPage })),
  },
  {
    path: "/webhooks/:webhookId",
    handle: { title: s.webhooksTitle },
    lazy: () => import("./pages/WebhookDetailsPage").then((m) => ({ Component: m.WebhookDetailsPage })),
  },
];

/** Manage API keys and Webhooks (compat spec 5.2, settings.md 18-19); no sidebar entries (routes.md 2). */
export const publicApiModule: AppModule = {
  name: "public-api",
  routes: { shell: shellRoutes },
};
